import React from 'react';
import { getFilteredClasses } from '../../../utils';
import { ILabel } from './types';
import styles from './styles.module.scss';

const Label = ({ children, className, id, ...rest }: ILabel) => {
  const filteredClasses = getFilteredClasses([className, styles.label]);

  return (
    <label htmlFor={id} {...rest} className={filteredClasses}>
      {children}
    </label>
  );
};

export { Label };
